"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var QueryError_1 = require("../../client/errors/QueryError");

var QueryErrorBoundary =
/** @class */
function (_super) {
  __extends(QueryErrorBoundary, _super);

  function QueryErrorBoundary(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      hasError: false
    };

    _this.restart = function () {
      _this.setState({
        hasError: false,
        response: undefined
      });
    };

    _this.state = {
      hasError: false,
      response: undefined
    };
    return _this;
  }

  QueryErrorBoundary.getDerivedStateFromError = function (error) {
    if (error instanceof QueryError_1.QueryError) {
      return {
        hasError: true,
        response: error.response
      };
    }
  };

  QueryErrorBoundary.prototype.render = function () {
    if (this.state.hasError && this.state.response && this.state.response.status && this.props.statuses.includes(this.state.response.status)) {
      return this.props.fallback(this.state.response, this.restart);
    }

    return this.props.children;
  };

  return QueryErrorBoundary;
}(react_1.Component);

exports.QueryErrorBoundary = QueryErrorBoundary;